import axios from "axios";
import {
  UPLOAD_XML_ZIP_FILE,
  UPLOAD_XML_ZIP_FILE_FAILED,
  UPLOAD_XML_ZIP_FILE_SUCCESS,
} from "./actionType";
// const baseURL = "https://rp6pb2z5-7070.inc1.devtunnels.ms/"; // You can keep this for testing or change as per your environment
const baseURL = process.env.REACT_APP_API_BASE_URL;

export const uploadXmlZipFileAction = (formData) => async (dispatch) => {
  try {
    // Dispatch the initial upload action to show loading state
    dispatch({
      type: UPLOAD_XML_ZIP_FILE,
    });

    const response = await axios.post(
      `${baseURL}aggregation/xml-upload`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data", // Use multipart/form-data for file uploads
          "ngrok-skip-browser-warning": "69420", // If you're using ngrok, otherwise you can remove this
        },
        timeout: 600000, // Timeout is set to 10 minutes, consider adjusting if not needed
      }
    );

    // Handle response status
    if (response.status >= 200 && response.status < 400) {
      dispatch({
        type: UPLOAD_XML_ZIP_FILE_SUCCESS,
        payload: response.data, // Axios automatically parses the response body to JSON
      });
    } else {
      dispatch({
        type: UPLOAD_XML_ZIP_FILE_FAILED,
        payload: response?.statusText || "Something went wrong",
      });
    }
  } catch (error) {
    // Handle axios errors
    let errorMessage = "Something went wrong";

    if (axios.isAxiosError(error)) {
      if (error.response) {
        // Server responded with a status other than 2xx
        errorMessage =
          error.response?.data?.message ||
          error.response?.statusText ||
          "Error in server response";
      } else if (error.request) {
        // No response from server
        errorMessage = "Network Error";
      } else {
        // Something else went wrong in setting up the request
        errorMessage = error.message;
      }
    }

    // Dispatch failure action
    dispatch({
      type: UPLOAD_XML_ZIP_FILE_FAILED,
      payload: errorMessage,
    });
  }
};
